export default __webpack_public_path__ + "static/media/arrow-down-white.a12e9f23.svg";